var exports = {
  "nf": "xae11d333--02a0aa--link",
  "ve": "xae11d333--02a0aa--all-category",
  "Kk": "xae11d333--02a0aa--icon",
  "Qq": "xae11d333--02a0aa--text",
};

module.exports = exports;
